import theme from 'ThemeProvider/theme';
import sx from 'utils/createSx';

export default sx({
  container: {
    minHeight: '100vh',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '50vh',
  },

  errorAlert: {
    marginBottom: theme.spacing(2),
  },

  // Breadcrumbs
  breadcrumbs: {
    marginBottom: theme.spacing(3),
    fontSize: '0.875rem',
  },
  breadcrumbLink: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  breadcrumbCurrent: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },

  // Wrapper da imagem (para posicionar os selos)
  imageWrapper: {
    position: 'relative',
  },
  // Selos Sem Álcool / Sem Glúten (canto superior esquerdo, sobre a imagem)
  stampsBadge: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    zIndex: 2,
  },
  stampIcon: {
    width: 66,
    height: 66,
    objectFit: 'contain',
  },
  // Selo LowCarb (canto superior direito, sobre a imagem)
  stampsBadgeRight: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    zIndex: 2,
  },
  // Imagem do produto
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '500px',
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
  },
  productImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },

  // Card de preços
  priceCard: {
    height: 'fit-content',
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
  },
  cardContent: {
    padding: theme.spacing(3),
  },

  // Informações do produto
  productName: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  brewery: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  productInfo: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },

  // Seção de preços
  priceSection: {
    position: 'relative',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
  },
  discountBadge: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: theme.palette.primary.main, // darkAmber
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  discountIcon: {
    fontSize: '0.875rem',
  },
  discountText: {
    fontWeight: 'bold',
    fontSize: '0.75rem',
  },
  originalPrice: {
    textDecoration: 'line-through',
    color: theme.palette.text.secondary,
    fontSize: '1.2rem',
  },
  currentPrice: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginTop: theme.spacing(0.5),
  },

  // Seção de assinante
  subscriberSection: {
    backgroundColor: theme.palette.primary.main, // darkAmber
    color: theme.palette.common.white,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(3),
    textAlign: 'center',
  },
  subscriberLabel: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  subscriberPrice: {
    fontWeight: 'bold',
    color: theme.palette.common.white,
    marginBottom: theme.spacing(1),
  },
  savingsText: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
    display: 'block',
    fontWeight: 'bold',
  },
  subscribeButton: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main, // darkAmber
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
  },

  // Controle de quantidade
  quantitySection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  quantityLabel: {
    fontWeight: 500,
  },
  quantityControls: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  quantityButton: {
    minWidth: '40px',
    height: '40px',
  },
  quantityValue: {
    minWidth: '30px',
    textAlign: 'center',
    fontWeight: 'bold',
  },

  // Botão adicionar ao carrinho
  addToCartButton: {
    backgroundColor: theme.palette.primary.main, // darkAmber
    color: theme.palette.common.white,
    fontWeight: 'bold',
    fontSize: '1.1rem',
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.grey[600],
    },
  },
  outOfStockText: {
    textAlign: 'center',
    color: theme.palette.error.main,
    fontStyle: 'italic',
  },

  // Seção de descrição
  descriptionSection: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  description: {
    lineHeight: 1.8,
    marginBottom: theme.spacing(4),
    fontSize: '1.1rem',
    color: theme.palette.text.primary,
  },

  // Informações técnicas
  technicalInfo: {
    marginTop: theme.spacing(3),
  },
  infoLabel: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '0.8rem',
    marginBottom: theme.spacing(0.5),
  },
  infoValue: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
});
